export default __webpack_public_path__ + "assets/models/f1175146fef363ead45c8b645fedba46.gltf";